/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { shape } from 'prop-types';
import { formatDate } from 'Helpers/date-utils';
import IconMemo from 'Assets/images/pages/web-chat/referral-memo.svg';

import style from './Memo.less';

const MemoItem = ({ item: { patientName, createdAt, ...rest } }) => (
  <a
    href={rest?.referralMemoFileInfo?.originalPath}
    target="_blank"
    className={style.item}
    rel="noreferrer">
    <strong className={style.title}>
      <img src={IconMemo} alt="mc" /> Referral Letter
    </strong>
    <div className={style.meta}>{formatDate(createdAt, 'MMM DD,YYYY')}</div>
  </a>
);

MemoItem.propTypes = {
  item: shape({}).isRequired,
};

MemoItem.defaultProps = {};

export default MemoItem;
